import { useState, useCallback } from 'react';
import { getAccessToken } from '../Services/authToken';

export interface GenerateTokenResponse {
  message?: string;
  expiresInMinutes?: number;
  ok?: boolean;
  reason?: string;
  showForgotPassWord?: boolean;
}
export interface RegisterResponse {
  ok: boolean;
  success?: boolean;
  reason?: string;

}

export interface LoginResponse {
  ok: boolean;
  reason?: string;
  message?: string;
  data?: any;
  otp_required?: boolean;
  masked_email?: string;
}

const hostname = window.location.hostname;
let baseurl = '';
if (hostname.includes('localhost')) {
  baseurl = 'http://localhost:8080';
} else if (hostname.includes('dev')) {
  baseurl = 'https://candidateinterviewscheduler-dev.pwc.com';
} else if (hostname.includes('stg') || hostname.includes('stage')) {
  baseurl = 'https://candidateinterviewscheduler-stg.pwc.com';
} else {
  baseurl = 'https://candidateinterviewscheduler.pwc.com'; // fallback production
}
const API_BASE = 'https://webapp-bs-candidate-management.dev.ngc.pwcinternal.com/api';

export async function forgetpasswordToken(email: string, password: string): Promise<GenerateTokenResponse> {
  const res = await fetch(`${baseurl}/api/candidate-dashboard/auth/forget-password-generate-token`, {
    method: 'POST',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  const data = await res.json();
  return {
    ...data,
    ok: res.ok,
    status: res.status
  };
}

export async function generateToken(email: string, password: string): Promise<GenerateTokenResponse> {
  const res = await fetch(`${baseurl}/api/candidate-dashboard/auth/generate-token`, {
    method: 'POST',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  if (!res.ok) throw new Error(`Generate token failed: ${res.status} ${res.statusText}`);
  return res.json();
}



export async function registerCandidate(email: string, password: string, tokenInput: string): Promise<RegisterResponse> {
  const res = await fetch(`${baseurl}/api/candidate-dashboard/auth/register`, {
    method: 'POST',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password, tokenInput }),
  });
  if (!res.ok) throw new Error(`Register failed: ${res.status} ${res.statusText}`);
  return res.json();
}


export async function changePasswordCandidate(email: string, password: string, token: string): Promise<RegisterResponse> {
  console.log(token);
  const res = await fetch(`${baseurl}/api/candidate-dashboard/auth/reset-password`, {
    method: 'POST',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password, token }),
  });
  if (!res.ok) throw new Error(`Register failed: ${res.status} ${res.statusText}`);
  return res.json();
}

export async function loginCandidate(email: string, primaryEmail?: string): Promise<LoginResponse> {
  const token = await getAccessToken(); const res = await fetch(`${baseurl}/api/candidate-dashboard/auth/login`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify({ email, primary_email: primaryEmail ?? '' }),
  });
  if (!res.ok) throw new Error(`Login failed: ${res.status} ${res.statusText}`);
  const data = await res.json();
  console.log('[DEBUG] Login response:', data);
  return data;
}

async function postWithToken(path: string, body?: object): Promise<{ ok: boolean; message?: string; status?: number }> {
  const token = await getAccessToken();
  const res = await fetch(`${baseurl}/api/candidate-dashboard/${path}`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(body ?? {}),
  });
  const data = await res.json().catch(() => ({}));
  return { ...data, ok: res.ok && data.ok !== false, status: res.status };
}

const typedPrimary = () => sessionStorage.getItem('typed_primary_email') ?? '';
export const sendLinkOtp = () => postWithToken('auth/link-otp/send', { primary_email: typedPrimary() });
export const verifyLinkOtp = (otp: string) => postWithToken('auth/link-otp/verify', { otp, primary_email: typedPrimary() });